import React from 'react'
import { Modal, Grid, Typography, Avatar, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import { selectWelcomPopup, userFirstAction } from '../../actions/mainSlice';
import { getAnalytics, logEvent } from "firebase/analytics";
import thinking from '../../assets/growing.png'
import ensemble from '../../assets/ensemble.png'
import musicprod from '../../assets/musicprod.png'
import piano from '../../assets/piano.png'

const style = {
  width: '88vw',
  m: '5% auto',
  maxWidth: 808,
  height: '90vh',
  overflowY: 'scroll',
  overflowX: 'hidden',
  bgcolor: 'primary.main',
  border: '2px solid #000',
  color: '#fff',
  boxShadow: 24,
  borderRadius: '16px',
  p: 2,
};


const WelcomePopup = () => {
    const analytics = getAnalytics()
    const dispatch = useDispatch()
    const welcomPopup = useSelector(selectWelcomPopup)

    const enterSite = () => {
        dispatch(userFirstAction())
        logEvent(analytics, 'onboarding_done', {});
    }

    return <Modal
            open={(welcomPopup === null && welcomPopup !== true)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Grid container spacing={1} sx={style}>
                <Grid size={12} sx={{mb: 1}}> 
                    <Typography textAlign='center' id="modal-modal-title" variant="h3" component="h2" sx={{fontWeight: 600}}>
                    Bienvenue sur Meka !
                    </Typography>
                </Grid>
                <Grid container spacing={2} sx={{padding: '1.8rem'}}>
                    <Grid size={{xs: 12, md:0, lg:0}} sx={{display: {xs: 'flex', md:'none', lg:'none'}}}>
                        <Avatar alt='en reflexion' src={thinking} sx={{m: '0 auto'}} />
                    </Grid>
                    <Grid size={{xs: 12, md:10, lg:10}}> 
                        <Typography id="modal-modal-description" sx={{ textAlign: 'left' }}>
                        Notre plateforme est le point de départ de plusieurs idées. C'est encore un peu flou
                        et c'est volontaire. On veut garder un peu de mystère et d'intérêt, mais surtout 
                        on veut la construire ce projet avec vous.
                        </Typography>
                    </Grid>
                    <Grid alignContent={'center'} alignItems={'center'} size={{xs: 0, md:2, lg:2}} sx={{display: {xs: 'none', md:'flex', lg:'flex'}}}>
                        <Avatar alt='en reflexion' src={thinking} sx={{m: '0 auto'}}/>
                    </Grid>
                </Grid>
                <Grid size={12} container spacing={2} sx={{padding: '1.8rem'}}>
                    <Grid alignContent={'center'} size={{xs: 12, md:2, lg:2}} >
                        <Avatar alt='ensemble' src={ensemble} sx={{m: '0 auto'}} />
                    </Grid>
                    <Grid size={{xs: 12, md:10, lg:10}}> 
                        <Typography id="modal-modal-description" sx={{ textAlign: 'left'}}>
                        Notre premier objectif est de réunir une communauté.<br></br><br></br>
                        <b>Vous aimez la musique ?</b> <b>Bienvenue</b>, vous êtes avec nous !<br></br><br></br>
                        Vous pouvez nous écrire ici : <a href='mailto:pim@meka-app.com'>pim@meka-app.com</a>
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{padding: '1.8rem'}}>
                    <Grid size={{xs: 12, md:0, lg:0}} sx={{display: {xs: 'flex', md:'none', lg:'none'}}}>
                        <Avatar alt='production musique' src={musicprod} sx={{m: '0 auto'}}/>
                    </Grid>
                    <Grid size={{xs: 12, md:10, lg:10}} > 
                        <Typography id="modal-modal-description" sx={{ textAlign: 'left' }}>
                        À ce jour, vous allez pouvoir trouver, à travers nos expériences, le résultat d'une volonté
                        de mettre en lumière les créateurs de la musique. Avec cette envie, le premier profil qui nous est 
                        paru évident est celui des producteurs.
                        </Typography>
                    </Grid>
                    <Grid alignContent={'center'} alignItems={'center'} size={{xs: 0, md:2, lg:2}} sx={{display: {xs: 'none', md:'flex', lg:'flex'}}}>
                        <Avatar alt='production musique' src={musicprod} sx={{m: '0 auto'}}/>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{padding: '1.8rem'}}>
                    <Grid size={{xs: 12, md:2, lg:2}} >
                        <Avatar alt='composition' src={piano} sx={{m: '0 auto'}}/>
                    </Grid>
                    <Grid size={{xs: 12, md:10, lg:10}}> 
                        <Typography id="modal-modal-description" sx={{ textAlign: 'left' }}>
                        C'est leur métier qui inspire le nom de cet endroit, ces personnes qui fabriquent la musique,
                        tels des artisans au savoir millénaire. 
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <Typography id="modal-modal-description" sx={{ textAlign: 'right' }}>
                        メーカー。作る人。
                        </Typography>
                    </Grid>
                </Grid>
                <Grid size={6} offset={6} sx={{mt: 3}} >
                    <Button color='secondary'><a href='mailto:pim@meka-app.com'>En savoir plus</a></Button>
                    <Button color='secondary' onClick={() => enterSite()}>Accéder au site</Button>
                </Grid>
            </Grid>
        </Modal>
         
}

export default WelcomePopup